export class SmartPageWidgetSettings {
  public marketingActions: MarketingAction[];
}

export class MarketingAction {
  public enabled: boolean;
  public widgetId: number;
  public sort: number;
}
